import React, { useEffect } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';

import { uiStore } from '../../core/stores/ui-store';
import { Header } from '../project/project.page';
import { Link, useParams } from 'react-router-dom';
import { ChevronRightIcon } from '@radix-ui/react-icons';
import { TaskDetail } from '../../features/tasks/components/task-detail';
import { Task } from '../../app/entities';

export const SpaceTaskRoute: React.FC = observer(() => {
  const { taskId } = useParams();
  const task = Task.getOne(taskId) as Task;

  useEffect(() => {
    uiStore.currentLocation = 'space.tasks';

    return () => {
      uiStore.currentLocation = '';
    };
  }, []);

  return (
    <Container>
      <Header>
        <Crumb>
          <Parent to="../">Tasks</Parent>
          <ChevronRightIcon />
          {task.title}
        </Crumb>
      </Header>

      <Scroller>
        <TaskDetail task={task} />
      </Scroller>
    </Container>
  );
});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 100%;
`;

const Scroller = styled.div`
  overflow-y: scroll;
  padding-top: 2.4rem;
`;

const Crumb = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.4rem;
`;

const Parent = styled(Link)`
  color: #e3e4e7;

  &:hover {
    color: white;
  }
`;
